import React from 'react';
import PropTypes from 'prop-types';

import parseTrackingPageUrl from '../support/parseTrackingPageUrl';

import ErrorPage from '../components/ErrorPage';

function TrackingPageAppWithUrl(props) {
  const { trackingPageId, orderId, zipCode } = parseTrackingPageUrl(props.pathname);

  if (trackingPageId && orderId) {
    return props.children({ trackingPageId, orderId, zipCode });
  }

  return <ErrorPage type="error" />;
}

TrackingPageAppWithUrl.propTypes = {
  pathname: PropTypes.string,
  children: PropTypes.func,
};

export default React.memo(TrackingPageAppWithUrl);
